/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown> }} Invite_X15_Join_AsInputs */

const en_invite_x15_join_as = /** @type {(inputs: Invite_X15_Join_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Join as ${i?.current}`)
};

/**
* | output |
* | --- |
* | "Join as {current}" |
*
* @param {Invite_X15_Join_AsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const invite_x15_join_as = /** @type {((inputs: Invite_X15_Join_AsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_Join_AsInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_invite_x15_join_as(inputs)
});